export class Observer {
  private message: { [key: string]: Array<(payload?: any) => any> } = {};
  // 订阅
  public regist(type: string, fn: (payload?: any) => any) {
    this.message[type] ? this.message[type].push(fn) : this.message[type] = [fn];
  }
  // 发布
  public emit(type: string, payload?: any) {
    if (!this.message[type]) {
      return;
    }
    this.message[type].forEach((fn) => fn(payload));
  }
  // 退订
  public remove(type: string, fn: () => any) {
    if (!this.message[type].includes(fn)) {
      return;
    }
    const idx = this.message[type].indexOf(fn);
    this.message[type].splice(idx, 1);
  }
}
